module.exports = __webpack_public_path__ + "img/users.2a66bbee.svg";